<template>
  <form>
    <base-card>
      <product-image @setImage="setImage" :image="targetItem.image" class="two" />
      <base-input
        :label="StringLanguage.productName"
        v-model="targetItem.name"
        :valid="isValidField('main', 'name')"
        class="mb_20"
      />
      <base-textarea
        :label="`${StringLanguage.ingredients} / ${StringLanguage.description}`"
        v-model="targetItem.description"
        class="mb_20"
        rows="4"
      />
      <base-select
        title="Tipo de bebida"
        v-model="targetItem.group"
        :valid="isValidField('main', 'group')"
        class="mb_0"
      >
        <option
          v-for="(drinkGroup, i) in availableDrinkGroups"
          :key="`drink-group-${i}`"
          :value="drinkGroup"
        >
          {{ DrinkGroupName[drinkGroup] }}
        </option>
      </base-select>
    </base-card>

    <div v-if="!originCategory.default_sizes">
      <div v-if="targetItem.sizes.length > 0">
        <div v-for="size in targetItem.sizes" :key="size._id">
          <base-card class="relative" v-if="!size.delete">
            <p class="step-title" :class="'text-center'">
              {{
                !!size.name && !!size.package && !!size.unit && !!size.amount
                  ? size.name
                  : "Novo Tamanho"
              }}
            </p>
            <div
              class="step-icons"
              v-if="targetItem.sizes.length > 1"
              @click.prevent="deleteItem(size._id)"
            >
              <span><i class="fal fa-times"></i></span>
            </div>

            <div class="d-flex">
              <div class="flex mr-10">
                <base-select
                  title="Embalagem"
                  v-model="size.package"
                  v-on:change="applyValue(size._id, 'package', size.package)"
                  :valid="isValidField(size._id, 'package')"
                >
                  <option
                    v-for="(packageType, i) in availablePackages"
                    :key="`package-${i}`"
                    :value="packageType"
                    :selected="size.package == packageType"
                  >
                    {{ PackageNames[packageType] }}
                  </option>
                </base-select>
              </div>
              <div class="d-flex">
                <div class="input-money mr-10">
                  <base-input
                    :label="StringLanguage.value"
                    v-model="size.price"
                    :valid="isValidField(size._id, 'price')"
                    v-on:change="applyValue(size._id, 'price', size.price)"
                    :money-mask="StringLanguage.currencyConfigs"
                  />
                </div>
                <div class="input-money">
                  <base-input
                    :label="StringLanguage.promo"
                    v-model="size.originalPrice"
                    :valid="isValidField(size._id, 'originalPrice')"
                    v-on:change="
                      applyValue(size._id, 'originalPrice', size.originalPrice)
                    "
                    :money-mask="StringLanguage.currencyConfigs"
                  />
                </div>
              </div>
            </div>

            <div class="row half-cols">
              <div class="col-xs-6">
                <base-input
                  :label="`Medida`"
                  class="mb_0"
                  v-model="size.amount"
                  :valid="isValidField(size._id, 'amount')"
                  v-on:change="applyValue(size._id, 'amount', size.amount)"
                />
              </div>
              <div class="col-xs-6">
                <base-select
                  title="Volume"
                  class="mb_0"
                  v-model="size.unit"
                  v-on:change="applyValue(size._id, 'unit', size.unit)"
                  :valid="isValidField(size._id, 'unit')"
                >
                  <option
                    v-for="(unit, i) in availableUnits"
                    :key="`unit-${i}`"
                    :value="unit"
                    :selected="size.unit == unit"
                  >
                    {{ unit }}
                  </option>
                </base-select>
              </div>
            </div>
          </base-card>
        </div>
      </div>
      <base-card>
        <div class="d-flex o-70">
          <base-button
            @click.prevent="addSize()"
            :text="'Adicionar tamanho'"
            design="four"
            class="w-100"
          />
        </div>
      </base-card>
    </div>

    <base-card v-else-if="targetItem.sizes && targetItem.sizes.length >= 1">
      <div class="row half-cols">
        <div class="col-lg-4 col-xs-4">
          <p class="text-title">{{ StringLanguage.size }}</p>
        </div>
        <div class="col-lg-4 col-xs-4">
          <p class="text-title">{{ StringLanguage.value }}</p>
        </div>
        <div class="col-lg-4 col-xs-4">
          <p class="text-title">{{ StringLanguage.promo }}</p>
        </div>
      </div>
      <div v-for="size in targetItem.sizes" :key="size._id">
        <div class="row half-cols">
          <div class="col-lg-4 col-xs-4">
            <base-input
              :value="size.name"
              class="mb_0"
              title="Para alterar este tamanho, vá até a categoria do produto"
              disabled
            />
          </div>
          <div class="col-lg-4 col-xs-4">
            <base-input
              v-model="size.price"
              class="mb_0"
              :money-mask="StringLanguage.currencyConfigs"
            />
          </div>
          <div class="col-lg-4 col-xs-4">
            <base-input
              v-model="size.originalPrice"
              class="mb_0"
              :money-mask="StringLanguage.currencyConfigs"
            />
          </div>
        </div>
      </div>
    </base-card>

    <!-- Disponibilidade -->
    <base-availability
      name="do produto"
      :availability="targetItem.availability"
      @updateAvailability="updateAvailability"
    ></base-availability>
    <!-- fim Disponibilidade -->
  </form>
</template>
<script>
import ProductImage from "@/containers/Catalog/ProductImage";
import Builder from "easyjs/lib/Schema/Components/Builder";
import Vue from "vue";
import { Money } from "v-money";
import { getXAPIEnv } from "@/plugins/account";

import BaseQuestion from "@/components/Question";
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";
import BaseTextarea from "@/components/Textarea";
import BaseSelect from "@/components/Select";

import StringTemplate from "easyjs/lib/Tools/StringTemplate";
import BaseAvailability from "@/containers/Availability";
import {
  PackageType,
  PackageNames,
} from "easyjs/lib/Schema/Components/PackageType";
import { VolumeUnit } from "easyjs/lib/Schema/Components/Unit";

import { DrinkGroup, DrinkGroupName } from "easyjs/lib/Schema/Components/Drink";

export default {
  data() {
    return {
      StringTemplate,
      PackageNames,
      DrinkGroupName,
      targetItem: Builder.factory("Drink"),
      originCategory: {},
      availableDrinkGroups: [
        DrinkGroup.AGUA,
        DrinkGroup.CACHACA,
        DrinkGroup.CAFE,
        DrinkGroup.CERVEJA,
        DrinkGroup.CHA,
        DrinkGroup.CONHAQUE,
        DrinkGroup.ENERGETICO,
        DrinkGroup.ESPUMANTE,
        DrinkGroup.GIM,
        DrinkGroup.ISOTONICO,
        DrinkGroup.LACTEA,
        DrinkGroup.LICOR,
        DrinkGroup.MILK_SHAKE,
        DrinkGroup.REFRIGERANTE,
        DrinkGroup.RUM,
        DrinkGroup.SAQUE,
        DrinkGroup.SUCO,
        DrinkGroup.TEQUILA,
        DrinkGroup.VINHO,
        DrinkGroup.VITAMINA,
        DrinkGroup.VODKA,
        DrinkGroup.WHISKY,
        DrinkGroup.OUTROS,
      ],
      availablePackages: [
        PackageType.COPO,
        PackageType.GALAO,
        PackageType.GARRAFA,
        PackageType.JARRA,
        PackageType.LATA,
        PackageType.LONGNECK,
        PackageType.OTHER,
      ],
      availableUnits: [VolumeUnit.mL, VolumeUnit.L],
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      deleteMode: {
        main: false,
        size: false,
      },
      errors: {
        main: [],
      },
    };
  },
  components: {
    ProductImage,
    BaseCard,
    BaseQuestion,
    BaseInput,
    BaseButton,
    BaseTextarea,
    BaseSelect,
    BaseAvailability,
  },
  computed: {
    environment() {
      return getXAPIEnv();
    },
  },
  methods: {
    updateAvailability(newAvailability) {
      Vue.set(this.targetItem, "availability", newAvailability);
    },
    setModel(item, parent) {
      this.cleanModel();
      this.originCategory = parent;
      this.targetItem = item || Builder.factory("Drink");
      this.targetItem.parent_ref = parent;
      this.targetItem.parent = parent._id || null;
      if (!this.targetItem.sizes || this.targetItem.sizes.length == 0) {
        if (this.originCategory.default_sizes) {
          this.targetItem.addItems(this.originCategory.sizes);
        } else {
          this.targetItem.sizes = [];
        }
      }
      this.targetItem.sizes.map((size) => {
        if (size.originalPrice > size.price) {
          let aux = size.price;
          size.price = size.originalPrice;
          size.originalPrice = aux;
        }
      });
    },
    setImage(fileName) {
      this.targetItem.image = fileName;
    },
    cleanModel() {
      this.errors = { main: [] };
      for (let key of Object.keys(this.deleteMode)) {
        this.deleteMode[key] = false;
      }
    },
    deleteItem(_id, showConfirm = true) {
      if (_id) {
        const deleteFn = () => {
          this.targetItem
            .getItemsByParam("_id", _id)
            .forEach((i) => Vue.set(i, "delete", true));
          //Remove todos os tamanhos que foram excluídos
          let catalog = Builder.factory("Catalog");
          catalog.addItems(this.targetItem);
          Builder.executeOnSchema(catalog, (item) => {
            if (item.sizes.length > 0) {
              Vue.set(
                item,
                "sizes",
                item.sizes.filter((s) => !s.delete)
              );
            }
          });
        };

        if (showConfirm) {
          confirm(StringLanguage.confirmDelete, (res) => res && deleteFn());
        } else {
          deleteFn();
        }
      } else {
        this.targetItem.delete = true;
        this.$emit("saveItem", this.targetItem);
      }
    },
    getItem() {
      return this.targetItem;
    },
    applyValue(_id, key, value) {
      this.targetItem.getItemsByParam("_id", _id).forEach((i) => {
        if (i.type == "size") {
          Vue.set(
            i,
            "name",
            `${PackageNames[i.package]} (${i.amount} ${i.unit})`
          );
        }
        Vue.set(i, key, value);
      });
    },
    addNewItem(type, target, node) {
      let item = (node || this.targetItem).getItemsByParam("_id", target)[0];
      let newItem = Builder.factory(type);
      newItem.new = true;
      newItem._id = Builder.generateRandomId("_");
      newItem.parent = item._id;
      item.addItems(newItem);
      return newItem;
    },
    addSize() {
      this.addNewItem("Size", this.targetItem._id);
      if (this.targetItem.new == false && this.targetItem.items.length > 0) {
        alert(
          "Tamanho adicionado com sucesso, configure os valores no produto."
        );
      }
    },
    isValidField(_id, field) {
      return !this.errors[_id] || this.errors[_id].indexOf(field) == -1;
    },
    highlightErrorFields() {
      this.errors = { main: [] };

      if (!this.targetItem.name) {
        this.errors.main = [...(this.errors.main || []), "name"];
      }

      if (!this.targetItem.group) {
        this.errors.main = [...(this.errors.main || []), "group"];
      }

      if (this.targetItem.sizes.length > 0) {
        this.targetItem.sizes.forEach((s) => {
          this.errors[s._id] = [
            !s.unit && "unit",
            !s.package && "package",
            !s.amount && "amount",
          ].filter((s) => !!s);
        });
      }
    },
  },
};
</script>
<style scoped>
.row.half-cols > *:not(:last-child) {
  padding-right: 7.5px;
}
.row.half-cols > *:not(:first-child) {
  padding-left: 7.5px;
}
.text-title {
  text-transform: uppercase;
  color: #868686;
  font-weight: 900;
  font-size: 10px;
  width: 100%;
}
.text-title.double:not(.left) {
  text-align: left !important;
  margin-bottom: 5px;
  padding-left: 5px;
}
.text-title.left {
  text-align: left !important;
  width: 120px;
  margin: 0 45px 0 30px;
}
.step-title {
  color: var(--label-primary);
  font-size: 1.4em;
  margin-bottom: 15px;
  font-weight: bold;
}
.step-icons {
  font-size: 1.4em;
  position: absolute;
  top: 25px;
  right: 0;
  color: var(--label-primary);
  cursor: pointer;
}

.step-icons i {
  font-size: 1em;
  padding: 0.25rem;
}
.input-money,
.label-money {
  width: 105px;
}
.mr-10 {
  margin-right: 10px;
}
</style>
